// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"255":"test","806":"user","884":"admin"}[chunkId] || chunkId) + "." + {"225":"61393950","238":"d5d19c06","255":"df1ce52a","683":"d3c613d7","710":"34c74c38","806":"e3bb85cc","884":"109c15fa","955":"6e7d4031"}[chunkId] + ".chunk.js";
};